<script>
import firebase from "firebase/app"

export default {
  mounted() {
    this.download()
  },
  methods: {
    download() {
      var storage = firebase.storage();
      var storageRef = storage.ref();
      var binRef = storageRef.child('arduino.bin');
      binRef.getDownloadURL()
      .then((url) => {
        // `url` is the download URL for 'images/stars.jpg'

        // This can be downloaded directly:
        var xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = () => {
          const blob = xhr.response;
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = 'arduino.bin';
          link.click();
          URL.revokeObjectURL(link.href);
        };
        
        xhr.open('GET', url);
        xhr.send();
      })
      .catch((error) => {
        // Handle any errors
        console.log(error)
      });
    }
  }
}
</script>